import FocusWidget from './FocusWidget';
import styles from './Dashboard.module.css';

export default function Dashboard() {
  return (
    <div className={styles.container}>
      <h1>Dashboard</h1>
      <p className={styles.subtitle}>Welcome to Charsoft Command Center</p>

      <div className={styles.grid}>
        <FocusWidget />

        <div className={styles.card}>
          <h2>Revenue Summary</h2>
          <p className={styles.placeholder}>Coming soon: Month-to-date revenue by bucket</p>
        </div>
      </div>
    </div>
  );
}
